import { render, staticRenderFns } from "./admin-transactions.vue?vue&type=template&id=68994490"
import script from "./admin-transactions.vue?vue&type=script&lang=js"
export * from "./admin-transactions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports